import { render, staticRenderFns } from "./appVersion.vue?vue&type=template&id=2c7341e7&"
import script from "./appVersion.vue?vue&type=script&lang=js&"
export * from "./appVersion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports